import { ExamQuestion } from "./exam-question.model";

export class Exam {
  id: number | null;
  date: Date;
  courseId: number;
  isFinished: boolean;
  score: number;
  examQuestions: ExamQuestion[];

  constructor(id: number | null, date: string, courseId: number, isFinished: boolean, score: number, examQuestions: any[]) {
    this.id = id;
    this.date = new Date(date);
    this.courseId = courseId;
    this.isFinished = isFinished;
    this.score = score;
    this.examQuestions = examQuestions ? examQuestions.map((examQuestion) => ExamQuestion.constructExamQuestion(examQuestion)) : [];
  }

  public static constructExam(raw: any): Exam {
    return new Exam(
      raw.id,
      raw.date,
      raw.courseId,
      raw.isFinished,
      raw.score,
      raw.examQuestions
    );
  }
}